import { useMutation } from '@tanstack/vue-query'

type SendCodePayload = {
  number: number
  country: { phone_code: string }
}

export const useSendSpecificVerifyCode = () => {
  return useMutation({
    mutationFn: async (payload: SendCodePayload) =>
      await $fetch('/api/verify/send-code', {
        method: 'POST',
        body: payload,
      }),
  })
}